import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import Spinner from '../../../../components/spinner/Spinner';
import OlRow from './OlRow';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const OlProbeDetails = ({ listOfSentences, fetchSentences }) => {
    useEffect(() => {
        if (isEmpty(listOfSentences)) {
            fetchSentences();
        }
    }, []);

    return isEmpty(listOfSentences) ? (
        <Spinner />
    ) : (
        <div className="container">
            <div className="oral-container">
                {listOfSentences.map((sentence, index) => (
                    <OlRow {...sentence} number={index + 1} key={generateReactKey(index)} />
                ))}
            </div>
        </div>
    );
};

OlProbeDetails.defaultProps = {
    fetchSentences: () => {},
    listOfSentences: [],
};

OlProbeDetails.propTypes = {
    fetchSentences: PropTypes.func,
    listOfSentences: PropTypes.array,
};

export default OlProbeDetails;
